import { useUnit } from 'effector-react'
import { $isUserGamedPremium, $userBalance, $userLanguage } from '@/entities/user'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { AvatarSteam } from '@/shared/ui/icons/steamAvatars'
import { lang } from '@/shared/constants/lang'
import { useStyles } from './styles'
import { formatNumber } from '@/shared/util/formatNumber'
import { CoinIcon } from '@/shared/ui/icons'
import Break from '@/shared/ui/break'

type ProfileCardProps = {
  variant: 'standard' | 'extended'
  style?: React.CSSProperties
}

export const ProfileCard = (props: ProfileCardProps) => {
  const { variant } = props
  const { classes } = useStyles()
  const userData = useUnit($steamUserData)?.userData
  const isPlusUser = useUnit($isUserGamedPremium)
  const userLang = useUnit($userLanguage)
  const standardTexts = lang[userLang].pages.updatePage
  const extendedTexts = lang[userLang].pages.profile
  const balance = useUnit($userBalance)

  if (variant === 'standard') {
    return (
      <div
        className={classes.header}
        style={props.style}
      >
        <div className={classes.user}>
          <AvatarSteam
            src={userData?.photoUrl ? userData.photoUrl : ''}
            alt={userData?.name ? userData.name : ''}
            width={40}
            height={40}
            isPlusUser={isPlusUser}
          />
          <div
            className={classes.usernameWrapper}
            id="123"
          >
            <span className={classes.meetText}>{standardTexts.meet}</span>
            <span className={classes.username}> {userData?.name}</span>
          </div>
        </div>
      </div>
    )
  }

  if (variant === 'extended') {
    return (
      <div className={classes.profileCard}>
        <div className={classes.headerExtended}>
          <AvatarSteam
            isSteamLogo
            isPlusUser={isPlusUser}
            src={userData?.photoUrl || ''}
          />

          <div className={classes.usernameExtendedWrapper}>
            <span className={classes.meetText}>{lang[userLang].pages.profile.meet}</span>
            <h3 className={classes.name}>{userData?.name}</h3>
          </div>
        </div>
        <Break />
        <div className={classes.totalStats}>
          <div className={classes.leftSide}>
            <h3 className={classes.title}>{extendedTexts.total_steam_value}</h3>
            <div className={classes.totalValueText}>$ {formatNumber(userData?.totalValue)}</div>
          </div>
          <div className={classes.rightSide}>
            <h3 className={classes.title}>{extendedTexts.balance}</h3>
            <div className={classes.totalBalance}>
              <CoinIcon classes={{ root: classes.coinIcon }} />
              {formatNumber(Number(balance))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
